import { createFileRoute } from '@tanstack/react-router';

import { requireRoute } from '@/router/guards';
import { passthroughSearch } from '@/router/search';
import Logs from '@/ui/pages/Logs/Logs';

export const Route = createFileRoute('/_dashboard/logs')({
  validateSearch: passthroughSearch,
  beforeLoad: requireRoute('/logs'),
  component: Logs,
});
